import React from 'react';
import './Abouttheiml.css';

const Abouttheiml = () => {
    return (
        <div className="Machinefear-container">

            <div className="Machinefear-text">
                <h2>About The IML System</h2>
                <ul>
                    <li>To achieve In Mold Labeling. Customers also need to purchase labels and labeling systems.
                    </li>
                    <li>It is generally recommended to purchase labels from the labeling system supplier. If there are problems with the color and size of the label, the labeling system supplier can directly solve the problem. And you need to use about 1000 labels and labeling machine to do the running test.</li>
                    <li>It is not recommended to purchase the labeling system separately. This is because it requires a test among the label, labeling system, injection molding machine and mold to make sure all system it’s running fine.</li>
                </ul>
            </div>
        </div>
    );
};

export default Abouttheiml;

